import React, { useEffect, useState } from 'react';
// import './CustomSlider-thirdwidth.css';
import './CustomSlider-thirdwidth steller.css';
import CardIcon from './CardIcon';

const CustomSliderThirdwidth = ({ onSlideClick }) => {
  const [files, setFiles] = useState([
    "hit output-1746108449623.mp4",
    "682489e6b9ac6b001343f1d0/1747225061291-tuoi_table2_-_Trim_output.mp4",
    "68189e78fe9c650013ed8f55/1746443896201-vin-diesel-poses-with-paul-walkers-daughter-meadow-3893288927_output.png",
    "682cb5f2b9ac6b001343f1d1/1747760624835-short_everest_Recording_2025-05-20_235908_-_Trim_output.mp4",


  ]);

  const [objs, setObjs] = useState([
    // {
    //   // "_id": {
    //   //   "$oid": "682cbc9cb9ac6b001343f1d5"
    //   // },

    //   // "status": "public",
    //   // "contributor": {
    //   //   "$oid": "671e566bf1105a8a7070e048"
    //   // },
    //   // "approved": false,
    //   // "mapId": "671e566bf1105a8a7070e048",
    //   // "userId": {
    //   //   "$oid": "674dc66916ff060013439d41"
    //   // },
    //   // "title": "Phan Thanh Nhiên, hay còn được biết đến với cái tên Nhân Lê, hiện là người Việt Nam trẻ nhất chinh phục đỉnh Everest. ",
    //   // "description": "Tags: N/A\\nLocation Name: N/A",
    //   "media": [
    //     {
    //       "_id": {
    //         "$oid": "682cbc9cb9ac6b001343f1d6"
    //       },
    //       "url": "obj.tang17so82duytan.com/demo-map/nice trim everest output - Trim-1747762330781.mp4",
    //       "type": "video",
    //       "createdAt": {
    //         "$date": "2025-05-20T17:32:12.321Z"
    //       }
    //     }
    //   ],
    //   "sharedWith": [
    //     {
    //       "permission": "view",
    //       "_id": {
    //         "$oid": "682cbc9cb9ac6b001343f1d7"
    //       },
    //       "userId": {
    //         "$oid": "671e566bf1105a8a7070e048"
    //       }
    //     }
    //   ],
    //   "createdAt": {
    //     "$date": "2025-05-20T17:32:12.330Z"
    //   },
    //   "tenantId": "674dc66916ff060013439d41",
    //   "__v": 0
    // },
    {
      // "location": {
      //     "coordinates": [
      //         21.031084209072286,
      //         105.78401685564293
      //     ],
      //     "type": "Point"
      // },
      "location": {
        "coordinates": [
          0,
          25
        ],
        "type": "Point"
      },
      "status": "public",
      "contributor": "671e566bf1105a8a7070e048",
      "approved": false,
      "_id": "682cbc9cb9ac6b001343f1d5", // ** do i need this 
      "mapId": "671e566bf1105a8a7070e048",
      "userId": "674dc66916ff060013439d41",
      "title": "Phan Thanh Nhiên, hay còn được biết đến với cái tên Nhân Lê, hiện là người Việt Nam trẻ nhất chinh phục đỉnh Everest. ",
      "description": "Tags: N/A\\nLocation Name: N/A",
      "media": [
        {
          "_id": "682cbc9cb9ac6b001343f1d6",
          "url": "obj.tang17so82duytan.com/demo-map/nice trim everest output - Trim-1747762330781.mp4",
          "type": "video",
          "createdAt": "2025-05-20T17:32:12.321Z",
          "thumbnailUrl": "obj.tang17so82duytan.com/demo-map/thumb-1749395812574-1747760624835-short_everest_Recording_2025-05-20_235908_-_Trim_output-1749395811149.jpg",
          // "thumbnailUrl": 'obj.tang17so82duytan.com/demo-map/thumb-1749379182254-hit2 output-1749379181864.jpg',
          // "thumbnailUrl": "obj.tang17so82duytan.com/demo-map/68189e78fe9c650013ed8f55/1746443896201-vin-diesel-poses-with-paul-walkers-daughter-meadow-3893288927_output.png",


        }
      ],
      "sharedWith": [],
      "createdAt": "2025-05-20T17:32:12.330Z",
      "tenantId": "674dc66916ff060013439d41",
      "__v": 0
    },
    {
      "location": {
        "coordinates": [
          21.031084209072286,
          105.78401685564293
        ],
        "type": "Point"
      },
      "status": "public",
      "contributor": "671e566bf1105a8a7070e048",
      "approved": true,
      "_id": "6845b743b9ef84001374a566",
      "mapId": "671e566bf1105a8a7070e048",
      "userId": "671e566bf1105a8a7070e048",
      "title": "Không phải cháu",
      "description": "Long Đặng",
      "media": [
        {
          "_id": "a2b3c4d5-e6f7-8901-bcde-f23456789012",
          "url": "obj.tang17so82duytan.com/demo-map/hit output-1746108449623.mp4",
          "type": "video",
          "createdAt": "2025-06-01T12:18:00.000Z",
          // "thumbnailUrl": "obj.tang17so82duytan.com/demo-map/thumb-1749379182254-hit2 output-1749379181864.jpg",
          "thumbnailUrl": "obj.tang17so82duytan.com/demo-map/thumb-1749396217935-hit2output-no_spaces.jpg",

        }
      ],
      "sharedWith": [],
      "createdAt": "2025-06-01T12:18:00.000Z",
      "tenantId": "64453588bc795e4680d274e1",
      "__v": 0
    },
    {
      "location": {
        "coordinates": [
          21.031084209072286,
          105.78401685564293
        ],
        "type": "Point"
      },
      "status": "public",
      "contributor": "671e566bf1105a8a7070e048",
      "approved": true,
      "_id": "6845b87cb9ef84001374a568",
      "mapId": "671e566bf1105a8a7070e048",
      "userId": "671e566bf1105a8a7070e048",
      "title": "Tuổi",
      "description": "",
      "media": [
        {
          "_id": "a2b3c4d5-e6f7-8901-bcde-f23456789012",
          // "url": "obj.tang17so82duytan.com/demo-map/682489e6b9ac6b001343f1d0/1747225061291-tuoi_table2_-_Trim_output.mp4",
          "url": "obj.tang17so82duytan.com/demo-map/xin cÃ¡i TUá»I __ThÃ´ng Nguyá»n (chá» Liá»u)__-1749399675768.mp4",
          "type": "video",
          "createdAt": "2025-06-01T12:18:00.000Z",
          "thumbnailUrl": "obj.tang17so82duytan.com/demo-map/thumb-1749400204945-Thong_Nguyen.jpg",


        }
      ],
      "sharedWith": [],
      "createdAt": "2025-06-01T12:18:00.000Z",
      "tenantId": "64453588bc795e4680d274e1",
      "__v": 0
    },
    {
      "location": {
        "coordinates": [
          21.031084209072286,
          105.78401685564293
        ],
        "type": "Point"
      },
      "status": "public",
      "contributor": "671e566bf1105a8a7070e048",
      "approved": true,
      "_id": "683c639db9ac6b001343f1e0",
      "mapId": "671e566bf1105a8a7070e048",
      "userId": "671e566bf1105a8a7070e048",
      "title": "a Hưng xxx",
      "description": "",
      "media": [
        {
          "_id": "a2b3c4d5-e6f7-8901-bcde-f23456789012",
          "url": "obj.tang17so82duytan.com/demo-map/68189e78fe9c650013ed8f55/1746443896201-vin-diesel-poses-with-paul-walkers-daughter-meadow-3893288927_output.png",
          "type": "video", // this type affected img display on popup v2, but i ask gpt to handle that case too, check the extention instead of merely depend on this 'type'
          "createdAt": "2025-06-01T12:18:00.000Z"
        }
      ],
      "sharedWith": [],
      "createdAt": "2025-06-01T12:18:00.000Z",
      "tenantId": "64453588bc795e4680d274e1",
      "__v": 0
    },
    // {
    //     "location": {
    //         "coordinates": [
    //             21.031084209072286,
    //             105.78401685564293
    //         ],
    //         "type": "Point"
    //     },
    //     "status": "public",
    //     "contributor": "671e566bf1105a8a7070e048",
    //     "approved": true,
    //     "_id": "f1b2c3d4-e5f6-7890-abcd-ef1234567890",
    //     "mapId": "671e566bf1105a8a7070e048",
    //     "userId": "671e566bf1105a8a7070e048",
    //     "title": "76 Duy Tân - Event Highlight",
    //     "description": "Highlight video from recent event at 76 Duy Tân",
    //     "media": [
    //         {
    //             "_id": "a2b3c4d5-e6f7-8901-bcde-f23456789012",
    //             "url": "obj.tang17so82duytan.com/demo-map/682cb5f2b9ac6b001343f1d1/1747760624835-short_everest_Recording_2025-05-20_235908_-_Trim_output.mp4",
    //             "type": "video",
    //             "createdAt": "2025-06-01T12:18:00.000Z"
    //         }
    //     ],
    //     "sharedWith": [],
    //     "createdAt": "2025-06-01T12:18:00.000Z",
    //     "tenantId": "64453588bc795e4680d274e1",
    //     "__v": 0
    // },  

  ]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [thumbnails, setThumbnails] = useState({});
  // const baseUrl = 'https://obj.tang17so82duytan.com/demo-map/'; // not used anymore



  useEffect(() => {
    // console.log("Files data:", files); // Log the files data

    // const fetchFiles = async () => {
    //   setLoading(true);
    //   try {
    //     const token = localStorage.getItem('authToken');
    //     const response = await fetch(`https://www.demo.comtruaduytan.com/wp-json/minio/v1/files?page=1&per_page=20`, {
    //       method: 'GET',
    //       headers: {
    //         'Authorization': `Bearer ${token}`
    //       }
    //     });
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     const data = await response.json();

    //     if (Array.isArray(data.files)) {
    //       setFiles(data.files);

    //       const videoFiles = data.files.filter(file => file.endsWith('.mp4') || file.endsWith('.webm'));
    //       videoFiles.forEach(file => {
    //         generateThumbnail(`${baseUrl}${file}`).then(thumbnail => {
    //           setThumbnails(prevThumbnails => ({
    //             ...prevThumbnails,
    //             [file]: thumbnail
    //           }));
    //         });
    //       });
    //     } else {
    //       throw new Error('Unexpected response format');
    //     }
    //     setLoading(false);
    //   } catch (err) {
    //     setError(err);
    //     setLoading(false);
    //   }
    // };

    // fetchFiles();

    // const generateThumbnails = async () => {
    //   for (const obj of objs) {
    //     const fileUrl = "https://" + obj.media[0].url;
    //     if (fileUrl.endsWith('.mp4') || fileUrl.endsWith('.webm')) {
    //       try {
    //         const thumbnail = await generateThumbnail(fileUrl);
    //         setThumbnails(prevThumbnails => ({
    //           ...prevThumbnails,
    //           [fileUrl]: thumbnail
    //         }));
    //       } catch (err) {
    //         console.error(`Error generating thumbnail for ${fileUrl}:`, err);
    //       }
    //     }
    //   }
    // };

    // generateThumbnails();
  }, [objs]);

  // const generateThumbnail = (videoUrl) => {
  //   return new Promise((resolve, reject) => {
  //     console.log("Generating thumbnail for:", videoUrl);
  //     const video = document.createElement('video');
  //     const canvas = document.createElement('canvas');
  //     const context = canvas.getContext('2d');

  //     video.src = videoUrl;
  //     video.currentTime = 5;

  //     video.addEventListener('seeked', () => {
  //       console.log("Video seeked successfully");
  //       canvas.width = video.videoWidth;
  //       canvas.height = video.videoHeight;
  //       context.drawImage(video, 0, 0, canvas.width, canvas.height);
  //       const thumbnailDataUrl = canvas.toDataURL();
  //       // console.log("Thumbnail generated:", thumbnailDataUrl);
  //       resolve(thumbnailDataUrl);
  //     });

  //     video.addEventListener('error', (error) => {
  //       console.error("Error during video seek/thumbnail generation:", error);
  //       reject(error);
  //     });
  //   });
  // };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="custom-slider-thirdwidth">
      {objs.map((obj, index) => {
        const fileUrl = "https://" + obj.media?.[0]?.url;
        const thumbnailUrl = "https://" + obj.media?.[0]?.thumbnailUrl;
        const fileExtension = fileUrl?.split('.').pop().toLowerCase();
        const isVideo = ['mp4', 'webm'].includes(fileExtension);
        const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);
        // const thumbnail = thumbnails[fileUrl]; // not used anymore

        console.log("############ CustomSlider-thirdwidth.js ###########")
        console.log("thumbnailUrl:", thumbnailUrl);

        let imageUrl = thumbnailUrl || 'https://via.placeholder.com/150'; // Use thumbnailUrl if available, otherwise default
        if (isImage) {
          imageUrl = fileUrl || 'https://via.placeholder.com/150';
        }

        return (
          <div
            key={index}
            className="bg-image-container-thirdwidth"
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              // objectFit: 'cover !important',      // ensures image covers the container without stretching

            }}

            // style={{
            //   width: '100px',
            //   height: '100px',
            //   borderRadius: '50%',
            //   objectFit: 'cover',      // ensures image covers the container without stretching
            //   objectPosition: 'center' // optional: centers the image inside the circle
            // }}            

            onClick={() => onSlideClick(obj)}
            onError={(e) => {
              e.target.style.backgroundImage = `url('https://via.placeholder.com/150')`; // Fallback image
            }}
          >
            <CardIcon />
            <div className="slider-label-thirdwidth">
              {'Category'}
            </div>
            <div className="slider-body-thirdwidth">
              {obj.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CustomSliderThirdwidth;
